
import { css } from 'lit';
export default css`
/* Apply CSS Variables to the host element. */
:host{
  --sic-search-teaser--default--text-color-default:var(
    --color-neutral-default
  );
  --sic-search-teaser--text-color-dark:var(--color-neutral-dark);
  --sic-search-teaser--default--eyebrow-font-size:14px;
  --sic-search-teaser--default--heading-font-size:var(--body-03-font-size);
  --sic-search-teaser--default--spacing-l:var(--spacing-08);
  --sic-search-teaser--default--spacing-m:var(--spacing-03);
  --sic-search-teaser--default--spacing-s:var(--spacing-02);
}
`;